import { FC, memo, useMemo } from 'react';
import { INavbarButtonProps } from './types';

export const NavbarButton: FC<INavbarButtonProps> = memo(
  ({ icon, text, onClick, navOpen = false, disabled = false, opacity = 30, iconWidth = 32 }) => {
    const linkIconStyle = `h-auto flex-centred opacity-${opacity}`;

    const navLinkStyle = useMemo(() => {
      const def =
        'flex items-center justify-start  no-underline rounded-full shadow-none bg-none border-none cursor-pointer';
      if (navOpen) return def;
      return `${def} transition-colors duration-200 ease-out hover:bg-white hover:shadow-[0_0_4px_rgba(0,24,43,0.2)] hover:duration-400 group`;
    }, [navOpen]);

    const iconTextStyle = useMemo(() => {
      const def = 'pl-[10px] inline-block whitespace-nowrap';
      if (navOpen) return def;
      return `${def} overflow-hidden max-w-0 transition-[max-width] duration-200 ease-out group-hover:max-w-[300px] group-hover:mr-[16px]`;
    }, [navOpen]);

    return (
      <button className={navLinkStyle} type="button" onClick={onClick} disabled={disabled}>
        <div className={linkIconStyle} style={{ width: iconWidth }}>
          {icon}
        </div>
        <p className={iconTextStyle}>{text}</p>
      </button>
    );
  }
);
